import { makeStyles } from "tss-react/mui"
import { TextField } from "@mui/material"
import React, { useEffect, useState } from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { sanitizeSearchQuery } from "../../../../../../lib/stringLib"

const useStyles = makeStyles()(() => ({
    textInput: {
        width: "15rem",
    },
}))

export function OrderIdInput({ value, onChange }: { value: string; onChange: (value: string) => void }) {
    const { classes } = useStyles()
    const { innerValue, debouncedValue, setInnerValue } = useDebouncedInput(value)

    useEffect(() => {
        if (debouncedValue !== value) {
            onChange(debouncedValue)
        }
    }, [debouncedValue, value, onChange])

    return (
        <LocalizedStrict id="supplier-meeting-service-order-id-label" attrs={{ label: true }}>
            <TextField
                className={classes.textInput}
                name="orderId"
                value={innerValue}
                label="Order ID"
                onChange={(e) => setInnerValue(sanitizeSearchQuery(e.target.value))}
            />
        </LocalizedStrict>
    )
}

export const useDebouncedInput = (initialValue: string, delay = 500) => {
    const [value, setValue] = useState(initialValue)
    const [debouncedValue, setDebouncedValue] = useState(initialValue)

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [value, delay])

    return { innerValue: value, debouncedValue, setInnerValue: setValue }
}
